import React from "react";
import {Link, NavLink, useHistory, useLocation} from 'react-router-dom';
import {observer} from "mobx-react-lite"
import menuStore from "common/menu/store/MenuStore";
import userStore from "common/user/store/UserStore";
import UIUtil from "utils/UIUtils";
import MenuInfo from "common/menu/model/MenuInfo";

interface AuthMenuLinkProp {
    menuId: string;
    isNav?: boolean;
    className?: string;
    children?: React.ReactNode;
}

function AuthMenuLink({menuId, isNav = false, className, children}: AuthMenuLinkProp) {
    const findTargetMenu = (menu?:MenuInfo) => {
        if(menu?.children && menu?.children.length)
            return findTargetMenu(menu.children[0]);
        return menu;
    }

    const menu = menuStore.menuList?.find(item => item.getMenuId() == menuId);
    const targetMenu = findTargetMenu(menu);

    const [canAccess, setCanAccess] = React.useState<boolean>();

    const history = useHistory();
    const location = useLocation();

    const notAuthority = () => {
        if (userStore.authenticated)
            UIUtil.alert(<>접근권한이 없습니다.<br/>(접근권한 문의(02-368-8700) 확인 하셨으면 다시 로그인 부탁드립니다.)</>).then();
        else
            UIUtil.alert("로그인이 필요합니다.").then(() => {
                history.push({
                    pathname: userStore.getLoginUrl(location.pathname.includes('/admin')),
                    search: `url=${menu?.menuPath}`
                });

            })
    }


    React.useEffect(() => {
        const authorities = userStore.userModel?.getAuthorities() || ["ROLE_ANONYMOUS"];
        setCanAccess(authorities?.some(auth => targetMenu?.getAuthorities().includes(auth)))
    })

    if (menu)
        if (canAccess) return (
            <>{isNav ?
                <NavLink to={targetMenu.menuPath} className={className}
                         onClick={() => menuStore.setCurrentMenu(targetMenu)}>{children ? children : menu.menuNm}</NavLink>
                :
                <Link to={targetMenu.menuPath} className={className}
                      onClick={() => menuStore.setCurrentMenu(targetMenu)}>{children ? children : menu.menuNm}</Link>
            }</>
        )
        else return (
            <a href={"#"} className={className} onClick={notAuthority}>{children ? children : menu?.menuNm}</a>
        )
    else return (
        <a href={"#"} className={className}>{children}</a>
    )
}

export default observer(AuthMenuLink);